<template>
    <div class="team-section">
      <h1 class="section-title">Rencontrez notre équipe</h1>
      <div class="team-grid">
        <div class="team-member" v-for="(member, index) in teamMembers" :key="index">
          <img :src="require(`@/assets/images/${member.photo}`)" alt="Photo" class="team-photo" />
          <h2 class="team-name">{{ member.name }}</h2>
          <p class="team-position">{{ member.position }}</p>
          <p class="team-description" v-html="member.description"></p>
          <a v-if="member.linkedin" :href="member.linkedin" class="linkedin-link" target="_blank">
            <i class="bi bi-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TeamSection',
    data() {
      return {
        teamMembers: [
          {
            name: 'Jean-Emmanuel RHIE',
            position: 'CEO',
            description: 'Jean-Emmanuel exerce dans les domaines de la gestion de patrimoine et du courtage en crédit depuis 2007. Il a fondé le Groupe FICODEV qu’il dirige et anime encore au quotidien. Co-fondateur et Président de la solution Prexange.',
            photo: 'JE.png',
            linkedin: 'https://www.linkedin.com/in/johndoe'
          },
          {
            name: 'Olivier LENDREVIE',
            position: 'Associé',
            description: 'Olivier a exercé dans la banque et les services financiers, en France et à l’international. Il a notamment été directeur général adjoint de la BRED (groupe BPCE) et président du réseau de courtage CAFPI. Il est le fondateur du site d’information économique <a href="http://www.moneysmart.fr" target="_blank">www.moneysmart.fr</a> et enseigne à HEC.',
            photo: 'olivier.png',
            linkedin: 'https://www.linkedin.com/in/janesmith'
          },
          {
            name: 'Christophe DEBOSQUE',
            position: 'Associé',
            description: 'Christophe DEBOSQUE est le co-fondateur de TBD Group, une agence e-commerce. Il est expert en IT et co-fondateur de Prexange',
            photo: 'chris.jpg'
          },
          {
            name: 'Arnaud BECQUART',
            position: 'CFO Associé',
            description: 'Arnaud Becquart est un multi-entrepreneur et investisseur, dans des domaines aussi variés que la sécurité informatique, le e-commerce, ou encore la gastronomie.l est notamment le co-fondateur de NBS System (hébergement sécurisé de données) et TBD Group (agences de développement e-commerce), qu’il dirige encore aujourd’hui.',
            photo: 'Arnaud.jpg'
          },
          {
            name: 'Afif KRAYEM',
            position: 'Développeur web',
            description: "Afif est un développeur web ayant 6 ans d'expérience dans la conception et le développement d'applications web.Il est le développeur principal derrière la plateforme Prexange .",
            photo: 'afif.jpg'
          }
        ]
      }
    }
  }
  </script>
  
  <style lang="scss">
  @import './equipe.scss'
  
  </style>
  